import { render, staticRenderFns } from "./GenerateKPOConfirmation.vue?vue&type=template&id=67fb9600&"
import script from "./GenerateKPOConfirmation.vue?vue&type=script&lang=js&"
export * from "./GenerateKPOConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports